import React from 'react';
import { motion } from 'framer-motion';
import { isEmpty, map } from 'lodash';
import BoxedContainer from './layouts/BoxedContainer';

export default function FreeZoneOurClients({ data, id }) {
  const { title, text, clientItems } = data;
  return (
    <section id={id} className="relative overflow-hidden pt-10 pb-[50px] md:py-[100px]">
      <BoxedContainer className="flex flex-col gap-y-[25px] md:gap-y-[50px]">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.4 }}
          viewport={{ once: true }}
          className="flex flex-col gap-y-6 lg:gap-y-[30px]">
          <div className="flex flex-col gap-y-5">
            <div
              dangerouslySetInnerHTML={{ __html: title }}
              className="text-clamp20to40  h2-child:text-clamp20to40 text-[#4A4A4A]
            h2-child:leading-1.2  h2-child:!m-0 text-center"
            />
            <div className="h-[2px] w-[70px] bg-[#CE445B] mx-auto" />
          </div>
          <div
            dangerouslySetInnerHTML={{ __html: text }}
            className="p-child:text-[#4A4A4A] p-child:text-clamp12to18 p-child:font-normal
            p-child:leading-[1.6] p-child:mb-0 p-child:ltr:font-URWDINRegular 
            p-child:rtl:font-GESSTwoDWTCLight text-center"
          />
        </motion.div>
        {isEmpty(clientItems) || (
          <div
            className="flex flex-col md:flex-row gap-5 md:gap-7 flex-wrap justify-center
          lg:px-[83px] items-center">
            {map(clientItems, (item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.3 * (index + 1), delay: 0.6 }}
                className="flex gap-7 items-center dot-rounded:last:hidden">
                <p className="text-clamp14to20 text-[#CE445B] ltr:font-URWDINRegular 
                rtl:font-GESSTwoDWTCLight ltr:leading-1 rtl:leading-[1.3] !m-0 text-center">
                  {item}
                </p>
                <span
                  className="w-[10px] h-[10px] relative rounded-full bg-[#CE445B]
                rounded-dots hidden md:flex"
                />
              </motion.div>
            ))}
          </div>
        )}
      </BoxedContainer>
    </section>
  );
}
